import React from "react";
import { connect } from "react-redux";
import { changeEtapas } from "../actions";
import { scrollElementToTop } from "../functions";

class FinalizarSensibilizacionPlanMovilidad extends React.PureComponent {
  componentDidMount = () => {
    scrollElementToTop("finalizar_sensibilizacion");
  }

  render() {
    return (
      <section id="finalizar_sensibilizacion">
        <div className="container-fluid">
          <div className="row PM-plan-borde-spacing">
            <div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center">
              <div className="col-md-8 p-lg-5 mx-auto my-5 cuadro-1">
                <div className="row col-md-12 PM-tipo-denuncias-select PM-plan-exito">
                  <div className="col-md-12 text-center">
                    <span className="PM-felicita"><strong>¡Felicitaciones!</strong></span>
                  </div>
                  <div className="col-md-12 text-center PM-section-title">Finalizaste la etapa de sensibilización</div>
                  <div className="col-md-12 text-center PM-info">
                    <p>Ahora que diste a conocer esta iniciativa, avanza a la siguiente etapa, en donde podrás generar un diagnóstico de la movilidad de tu centro de trabajo.</p>
                  </div>
                </div>
                <div className="PM-home-item_plan PM-plan-contador-finalizar">
                  <button
                    className="btn PM-dx-button-plan PM-dx-button-plan-100"
                    onClick={() => {
                      this.props.dispatch(changeEtapas(1));
                    }}
                  >Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="PM-footer">&nbsp;</div>
      </section>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalizarSensibilizacionPlanMovilidad);
